export enum RequestNatureOptions {
  Termination = "RES", // Résiliation
  Cancellation = "ANN", // Annulation
  Question = "QUE", // Poser une question
  Attestation = "ATTEST", // Demander une attestation
  Claim = "RECLAM", // Faire une réclamation
  ContractualDocuments = "DOC_CON", // Envoyer des documents contractuels
  Attachments = "PIECE", // Envoyer des pièces jointes
}
